<p>ペットらくのり</p>
<button id="ssn-test-pet-input" class="testButton" (click)="moveToPetInput()">ペットらくのり画面へ</button>
<button id="organizationSelectRequired" class="testButton" (click)="process()">操作中カード情報初期化</button>
